export module HeaderModule {
  export class Service {
    constructor() {
      // readCompleteActionイベントが発火したときにsetEventを呼び出します。
      document.addEventListener('readCompleteAction', () => {
        Service.setEvent();
      })
    }

    public static setEvent() {
      const StyledHeader__wrapper = document.querySelector('.StyledHeader__wrapper') as HTMLElement;
      const StyledHeader__globalMenuButtonLink = document.querySelector('.StyledHeader__globalMenuButtonLink') as HTMLElement;
      if (StyledHeader__wrapper && StyledHeader__globalMenuButtonLink) {
        StyledHeader__globalMenuButtonLink.addEventListener('click', (e: Event) => {
          e.preventDefault();
          // 現在のスクロール位置をbody data-scroll-positionに保存する
          const body = document.querySelector('body');
          // StyledHeader__globalMenuButtonLink をクリックしたら、StyledHeader__wrapperにis-activeクラスを付与する
          StyledHeader__wrapper.classList.toggle('is-active');
          // StyledHeader__wrapper .is-active が外れた場合は、bodyのスクロール位置をdata-scroll-positionに保存する
          if (!StyledHeader__wrapper.classList.contains('is-active')) {
            body?.setAttribute('data-scroll-position', window.pageYOffset.toString());
          }
          // さらに、bodyにis-modal-openクラスを付与する
          body?.classList.toggle('is-modal-open');
        });
      }

      // ハッシュが変更されたら、is-modal-openクラスを外す
      // is-active クラスを外す
      window.addEventListener('hashchange', () => {
        console.log('hashchange');
        const body = document.querySelector('body');
        body?.classList.remove('is-modal-open');
        StyledHeader__wrapper.classList.remove('is-active');
      });
    }

  }
}
